import { getLocalStorageItem, setLocalStorageItem } from '../utils';

const getDefaultVolume = () => getLocalStorageItem('video.volume') || 50;

const setDefaultVolume = (volume) => {
  setLocalStorageItem('video.volume', volume);
};

const getDefaultMutedState = () => {
  const muted = getLocalStorageItem('video.muted');
  return muted === 'false' ? false : muted;
};

const setDefaultMutedState = (state) => {
  setLocalStorageItem('video.muted', state);
};

const getAllowAutoplayState = () => {
  const allowAutoplay = getLocalStorageItem('video.allowAutoplay');
  return allowAutoplay !== 'false';
};

const setDefaultAllowAutoplayState = (state) => {
  setLocalStorageItem('video.allowAutoplay', state);
};

export {
  getDefaultVolume,
  setDefaultVolume,
  setDefaultMutedState,
  getDefaultMutedState,
  setDefaultAllowAutoplayState,
  getAllowAutoplayState,
};
